import Icon from "assets/icons";
import Button from "../..";
import Variant from "shared/enums/Variant";
import classNames from "classnames";
import { SaveCloseButtonProps } from "./types";

/**
 * Combination of Save And close Icon buttons.
 */

export default function SaveCloseButton(props: SaveCloseButtonProps) {
  return (
    <div className={classNames("saveCloseButtonGroup", props.className)}>
      <Button icon={<Icon.MatClose />} variant={Variant.ERROR} onClick={props.closeHandler} />
      <Button
        icon={<Icon.MatCheck />}
        variant={Variant.SUCCESS}
        disabled={props.saveDisabled}
        onClick={props.saveHandler}
      />
    </div>
  );
}
